import type { Catalog } from "../../en";
import { workflowsService } from "./workflows-service";
import { workflowsTriggers } from "./workflows-triggers";

/** Filipino: Workflows P5-3, path actions, the paths jump bar, undo / redo, problems on tiles and steps, and notes. */
export const workflowsExtras: Catalog["engage"]["workflows"]["extras"] = {
  history: {
    toolbar: "Kasaysayan ng pag-edit",
    undo: "I-undo",
    redo: "I-redo",
    undoAction: "I-undo: {{action}}",
    redoAction: "I-redo: {{action}}",
    nothingToUndo: "Walang i-a-undo",
    nothingToRedo: "Walang i-a-redo",
    undone: "Na-undo: {{action}}.",
    redone: "Na-redo: {{action}}.",
    addStep: "magdagdag ng {{step}} sa {{path}}",
    removeStep: "alisin ang {{step}} sa {{path}}",
    moveStep: "ilipat ang {{step}}",
    replaceStep: "palitan ang {{from}} ng {{to}}",
    editStep: "i-edit ang {{step}}",
    connect: "ikonekta ang {{exit}} sa {{path}}",
    disconnect: "i-disconnect ang {{exit}}",
    addPath: "magdagdag ng {{path}}",
    deletePath: "burahin ang {{path}}",
    renamePath: "palitan ang pangalan ng {{path}}",
    duplicatePath: "i-duplicate ang {{path}}",
    addNote: "magdagdag ng tala",
    editNote: "i-edit ang tala",
    deleteNote: "burahin ang tala",
    settings: "baguhin ang mga setting",
    translations: "i-edit ang mga salin",
    generic: "i-edit ang workflow",
  },
  paths: {
    actions: "Mga aksyon para sa {{path}}",
    rename: "Palitan ang pangalan",
    duplicate: "I-duplicate",
    delete: "Burahin",
    nameLabel: "Pangalan ng {{path}}",
    namePlaceholder: "Pangalanan ang path na ito",
    copyName: "{{name}} (kopya)",
    duplicated: "Na-duplicate bilang {{path}}.",
    renamed: "Napalitan ang pangalan: {{path}}.",
    full: "Gamit na ang lahat ng {{max}} path. Magbura muna bago mag-duplicate.",
    deleteTitle: "Burahin ang {{path}}?",
    deleteBody_one: "{{count}} koneksyon ang papunta rito at buburahin. Aalisin ang mga hakbang sa path na ito.",
    deleteBody_other: "{{count}} koneksyon ang papunta rito at buburahin. Aalisin ang mga hakbang sa path na ito.",
    deleteBodyNone: "Walang koneksyong papunta rito. Aalisin ang mga hakbang sa path na ito.",
    deleteNotes_one: "Mananatiling tala ng workflow ang {{count}} tala nito.",
    deleteNotes_other: "Mananatiling tala ng workflow ang {{count}} tala nito.",
    deleteConfirm: "Burahin ang path",
    deleted: "Nabura ang {{path}}.",
  },
  jumpBar: {
    label: "Mga path",
    list: "Listahan ng mga path",
    goTo: "Pumunta sa {{path}}",
    hasProblems: "may mga problema",
    current: "kasalukuyang path",
    noPaths: "Walang path",
  },
  problemCount_one: "{{count}} problema",
  problemCount_other: "{{count}} problema",
  publishHint_one: "Ayusin ang {{count}} problema bago i-publish",
  publishHint_other: "Ayusin ang {{count}} problema bago i-publish",
  problemsHere: "Mga problema sa {{path}}",
  notesChanged: "Nagbago ang mga tala",
  limit: {
    minutes_one: "{{count}} minuto",
    minutes_other: "{{count}} minuto",
    hours_one: "{{count}} oras",
    hours_other: "{{count}} oras",
    days_one: "{{count}} araw",
    days_other: "{{count}} araw",
  },
  problemParts: { text: "teksto", field_label: "label ng field", buttons: "mga button", label: "label ng button" },
  problems: {
    ...workflowsTriggers.problems,
    ...workflowsService.problems,
    no_summary_here: "Nagsisimula ang trigger na ito bago pa magkaroon ng usapan, kaya walang maibubuod.",
    no_first_path: "Dapat magsimula ang workflow sa Path A.",
    unknown_path: "Papunta sa Path {{path}}, na wala.",
    duplicate_step: "Dalawang beses ginamit ang step id na {{step}}.",
    exit_unset: "Pumili ng path para sa labasan na ito.",
    loop: "Bumabalik sa sarili ang Path {{path}}. Tanging path na naghihintay sa bisita ang puwedeng umikot.",
    invalid_field: "Kulang o hindi valid ang “{{field}}”.",
    note_unknown_path: "May tala sa Path {{path}}, na wala.",
    not_facing: "Walang bisitang makakausap ang trigger na ito.",
    needs_facing: "Kailangan ng trigger na ito ng hakbang na nakikita o sinasagot ng bisita.",
    needs_intent: "Piliin kung aling intent ang magsisimula ng workflow na ito.",
    needs_conversation: "Walang usapan ang trigger na ito para sa hakbang na ito.",
    missing_target_hand: "Piliin kung kanino ibibigay ang usapan.",
    missing_target_assign: "Piliin kung kanino itatalaga.",
    missing_target_notify: "Piliin kung sino ang aabisuhan.",
    bad_template: "Hindi valid na JSON ang custom na body. Ilagay sa loob ng panipi ang bawat variable, tulad ng {{example}}.",
    no_wait_here: "Nagsisimula ang trigger na ito bago pa magkaroon ng usapan, kaya hindi ito makapaghihintay.",
    no_rating_here: "Walang usapang mari-rate ang trigger na ito.",
    no_interrupt_here: "Walang usapang puwedeng mag-interrupt ang trigger na ito.",
    needs_minutes: "Piliin kung ilang minuto bago magsimula ang workflow na ito.",
    needs_value: "Pumili ng halagang ikukumpara sa {{field}}.",
    needs_number: "Numero ang ikinukumpara sa {{field}}.",
    reusable_settings: "Walang settings ang reusable na workflow; tumatakbo ito kapag tinawag.",
    no_hook_here: "Nagsisimula ang trigger na ito bago pa magkaroon ng usapan, kaya hindi ito makapaghihintay ng webhook.",
    no_reply_timer_here: "Nagsisimula ang trigger na ito bago pa magkaroon ng usapan, kaya hindi nito mapuputol sa oras ang paghihintay ng sagot.",
    no_snooze_here: "Nagsisimula ang trigger na ito bago pa magkaroon ng usapan, kaya walang maisa-snooze.",
    start_over_in_a: "Bumabalik sa Path A ang Magsimula ulit, kaya hindi ito magagamit sa loob ng Path A.",
    translation_unknown_step: "May salin na tumutukoy sa hakbang na wala.",
    translation_not_translatable: "Walang {{what}} na isasalin sa hakbang na ito.",
    translation_unknown_button: "May salin na tumutukoy sa button na {{button}}, na wala.",
    needs_plan: "Kailangan ng {{plan}} plan o mas mataas.",
    wait_too_long: "Naghihintay nang hanggang {{limit}} sa plan mo. Paikliin o mag-upgrade.",
    connector_forbidden_header: "Hindi puwedeng itakda sa workflow ang header na {{header}}. Ilagay ang mga credential sa endpoint sa Settings → Webhooks.",
    connector_duplicate_header: "Dalawang beses itinakda ang header na {{header}}.",
    connector_body_on_get: "Hindi puwedeng magkaroon ng body ang GET request.",
    connector_bad_body: "Hindi wastong JSON ang body ng request. Ilagay ang bawat variable sa loob ng panipi, gaya ng {{example}}.",
    connector_map_pointer: "Ang field ng sagot ay dapat path na nagsisimula sa slash, gaya ng /data/status.",
    connector_map_variable: "Letra, numero at _ lang ang gamitin sa na-save na variable.",
    connector_duplicate_output: "Dalawang beses kinokopya ang output na {{name}}.",
    connector_duplicate_target: "Pinupunan ng higit sa isang field ang {{variable}}.",
    connector_bad_path: "Hindi puwedeng may bahaging . o .. ang path, kahit naka-encode.",
    connector_path_format: "Dapat magsimula sa slash ang path at hindi puwede ang ?, #, @, backslash o espasyo. Gamitin ang mga query parameter para sa mga halagang may ?.",
    connector_row: "May di-wastong pangalan o masyadong mahabang halaga ang isang query parameter o header.",
    connector_timeout_facing: "Naghihintay ang bisita sa request na ito, kaya hanggang {{seconds}} segundo lang ito.",
  },
  notes: {
    title: "Mga tala",
    strip: "Mga tala tungkol sa workflow na ito",
    add: "Magdagdag ng tala",
    addToPath: "Magdagdag ng tala sa {{path}}",
    empty: "Wala pang tala. Mag-iwan ng tala para sa susunod na mag-e-edit ng workflow na ito.",
    emptyHint: "Para sa team mo ang mga tala. Hindi ito nakikita ng mga bisita.",
    label: "Tala",
    placeholder: "Sumulat ng tala para sa team mo",
    save: "I-save ang tala",
    delete: "Burahin ang tala",
    deleted: "Nabura ang tala.",
    count_one: "{{count}} tala",
    count_other: "{{count}} tala",
    full: "Hanggang {{max}} tala lang ang puwede sa isang workflow.",
    forPath: "Sa {{path}}",
    forWorkflow: "Sa workflow",
    open: "Mga tala ng {{path}}",
    openWorkflow: "Mga tala ng workflow",
    chars: "{{count}} sa {{max}}",
  },
};
